import React, { useContext, useState } from "react";
import "./VexTheme.css";
import HighlightImage from "../Common/highlightImagesCards/HighlightImage";
import { HighlightImageValid, SocialMediaValid } from "../Common/DivValidation";
import {
  defaultBackgroundImage,
  defaultProfileImage,
} from "../Common/DefaultImage";
import VerticalSlideSM from "../Common/socialMedia/VerticalSlideSM";
import { Link } from "react-router-dom";
// import QRModal from "../Common/QRModal";
import WebsiteBasic from "../Common/websiteCards/WebsiteBasic";
import ReviewCardBasic from "../Common/reviewCards/ReviewCardBasic";
import DownloadBasic from "../Common/fileDownloadsCards/DownloadBasic";
import { CardContext } from "../../store/CardContext";
import VerticalSlideSMVex from "../Common/socialMedia/VerticalSlideSMVex";
import { FaExchangeAlt } from "react-icons/fa";
import ExchangeContact from "../Common/exchangeContactModal/ExchangeContact";
import Footer from "../Common/footer/Footer";
import QRModal from "../Common/qrModals/QRModal";
import { FaUser } from "react-icons/fa";
import { TbArrowsExchange } from "react-icons/tb";
import { RiDirectionLine } from "react-icons/ri";
import phn from "../../../assests/img/phoneicon.svg";
import mail from "../../../assests/img/emailicon.svg";
import loc from "../../../assests/img/loactionicon.svg";
import WebsiteIconic from "../Common/websiteCards/WebsiteIconic";
import Website from "../Common/websiteCards/Website";
import WebsiteVex from "../Common/websiteCards/WebsiteVex";
import ReviewCardVex from "../Common/reviewCards/ReviewCardVex";
import SlideSocialMediaStandard from "../Common/socialMedia/SlideSocialMediaStandard";
import SlideSocialMediaStd from "../Common/socialMedia/SlideSocialMediaStd";
import HighlightImageVex from "../Common/highlightImagesCards/HighlightImageVex";
import { IoShareSocialOutline } from "react-icons/io5";
import { IoCloseOutline, IoLink } from "react-icons/io5";
import moreIcon from "../../../assests/img/more_icon.svg";
import { BsQrCodeScan } from "react-icons/bs";
import ContactCardStd from "../Common/contactCards/ContactCardStd";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../helpers/tapCountMutation";
function VexTheme({ preview, card, color, iconColor}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleButtons = () => {
    setIsOpen(!isOpen);
  };

  const [cardData] = useContext(CardContext);

  const {
    profileImage,
    backgroundImage,
    personalDetails,
    checkProfile,
    contactDetails,
    socialMedias,
    website,
    review,
    fileName,
    file1,
    file2,
    file3,
    file4,
    SMediaPostion,
    companyLogo,
    checkLogo,
    vCard,
    footerText,
  } = cardData;

  const files = {
    file1: file1,
    file2: file2,
    file3: file3,
    file4: file4,
  };
  const Highlightcolor = card?.colorCode ? card?.colorCode : "#101519";
  const Textcolor = card?.textColor ? card?.textColor : "#FFFFFF";
  // const iconColor = color ? color : "#FFFFFF";
  const HighlightImageCheck = HighlightImageValid();
  const BtIColor = card?.btIconColor ? card?.btIconColor : "#CCCCCC";
  const Iconcolor = card?.iconBgColor ? card?.iconBgColor : "#1A1F23";

  const SocialMediaImageCheck = SocialMediaValid();
  const array = personalDetails?.name ? personalDetails?.name?.split(" ") : "";

  const pfImage = backgroundImage ? backgroundImage : defaultBackgroundImage;

  const imageStyle = {
    backgroundSize: card?.bgImgType ? card?.bgImgType : "cover",
    backgroundPosition: "center",
    backgroundImage: `url(${card?.bgImg})`,
    backgroundRepeat: card?.bgImgRepeat ? card?.bgImgRepeat : "no-repeat",

  };

  const shareMail = (e) => {
    window.location = `mailto:${personalDetails?.email}`;
    e.preventDefault();
  };
  const shareMail2 = (e) => {
    window.location = `mailto:${personalDetails?.secondaryEmail}`;
    e.preventDefault();
  };
  const [qrModal, setQrModal] = useState(false);
  // const [showResults, setShowResults] = useState(false);
  // const onClick = () => setShowResults(true);

  const [showResults, setShowResults] = useState(false);
  const onClick = () => setShowResults(true);
  const handleClose = (e) => {
    setQrModal(false);
    setShowResults(false);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          text: "Please check it out.",
          url: window.location.href,
          title: "ZEEQR",
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    }
  };
  const exchangeButton = (

    <button
      // onClick={preview ? handleShare : ""}
      className="flex items-center justify-center mt-3 border w-full text-black rounded-lg text-[12px] font-medium py-2 px-2"
      style={{
        border: `1px solid ${Highlightcolor ? Highlightcolor : "black"
          }`,
      }}
    >
      <span
        className="flex items-center gap-2"
        style={{
          color: `${Highlightcolor ? Highlightcolor : "black"}`,
        }}
      >
        <TbArrowsExchange className="w-4 h-4" />
        Exchange Contacts
      </span>
    </button>
  );

  const directionButton = (
    <button
      // onClick={onClick}
      className="w-full h-[44px] py-2 px-4 rounded-md flex items-center justify-center hover:bg-gray-800 transition-colors duration-300 disabled:bg-gray-400 disabled:cursor-not-allowed"
      style={{
        backgroundColor: Highlightcolor || "black",
        color: isDarkColor(Highlightcolor) ? "white" : "black",
      }}
    >
      <RiDirectionLine
        className="mr-2"
        size={18}
      
      />
      <span className="font-medium text-[12px]">
        Directions
      </span>
    </button>
  )
  function isDarkColor(color) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128;
  }
  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button) => {
    // console.log("iiii");

    updateTapCount(queryClient, button);
  };
  // const imageStyle = {
  //   backgroundSize: card?.bgImgType ? card?.bgImgType : "cover",
  //   backgroundPosition: "center 150px",
  //   backgroundImage: `url(${card?.bgImg})`,
  //   backgroundRepeat: card?.bgImgRepeat ? card?.bgImgRepeat : "no-repeat",

  // };
  const BgColor = card?.bgColor ? card?.bgColor : "";
  const colorStyle = {
    backgroundSize: "100%",
    backgroundPosition: "center 150px",
    backgroundColor: BgColor,
  };
  const defaultStyle = {
    backgroundSize: "100%",
    backgroundPosition: "center 150px",
    backgroundImage: 'white'
  };
  return (
    <div className="flex justify-center">
      <div className="relative ">
        <div
          className="digitalcontainer4 fixed h-screen overflow-auto scrollbar-hide "
          // style={imageStyle} 
          style={card?.bgImg ? imageStyle : BgColor ? colorStyle : defaultStyle}
        >
          <div className=" mt-5 mx-3  ">
            {/* ------------------------------ first section -----------------------------  */}
            <div className="flex gap-2 ">
              <div className=" flex flex-col items-center gap-2 w-1/2 ">
                {/* {checkPfCard ? ( */}
                <div className="relative h-[100%] w-full bg-gradient-to-b from-[#383B42] to-[#000000] flex justify-center rounded-[22px]">
                  {checkProfile ? (
                    <>
                      {profileImage ? (
                        <img
                          className="h-full w-full object-cover rounded-[22px]"
                          src={profileImage}
                          alt=""
                        />
                      ) : (
                        <img
                          src={defaultProfileImage}
                          className="h-full w-full object-cover rounded-[22px]"
                          alt=""
                        />
                      )}
                    </>
                  ) : (
                    ""
                  )}

                  {/* Company logo positioned at the bottom-right */}
                  {companyLogo && checkLogo ? (
                    <div
                      className="absolute bottom-2 right-2 h-[60px] w-[60px] rounded-full  flex items-center justify-center"
                      style={{
                        padding: "4px",
                        backgroundColor: Highlightcolor
                          ? `${Highlightcolor}80`
                          : "rgba(0, 0, 0, 0.5)",
                      }}
                    >
                      <img
                        className="h-full w-full object-cover rounded-full"
                        src={companyLogo}
                        alt="Logo"
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div>
                <div
                  className="w-full h-fit rounded-[22px] items-center p-6"
                  style={{
                    backgroundColor: `${Highlightcolor ? Highlightcolor : "black"
                      }`,
                  }}
                >
                  <div
                    className={` ${checkProfile ? "" : "flex flex-col justify-start "
                      }  text-start text-white `}
                  >
                    <h1
                      className="font-bold "
                      style={{
                        // width: `${!checkProfile ? "max-content" : ""}`,
                        fontSize: `${array[0]?.length > 12 ||
                          array[1]?.length > 12 ||
                          array[2]?.length > 12
                          ? "15px"
                          : ""
                          }`,
                      }}
                    >
                      {" "}
                      {personalDetails?.name ? personalDetails.name : ""}
                    </h1>

                    <p className="text-[10px]  text-[#CCCCCC] font-medium text-start">
                      {personalDetails?.companyDesignation
                        ? personalDetails.companyDesignation
                        : ""}
                    </p>
                  </div>
                </div>
                <div
                  className={`buttons  gap-4 ${!card?.checkPfCard ? "mt-12" : "mt-4"
                    }`}
                >
                  <Link
                    className="addTo flex items-center justify-center gap-2 bg-black text-white py-2 px-4 rounded-lg text-[12px] font-medium"
                    onClick={() => handleTap('saveContact')}
                    to={`${preview ? card?.vCard : ""}`}
                    style={{
                      backgroundColor: `${Highlightcolor ? Highlightcolor : "black"
                        }`,
                    }}
                  >
                    <FaUser className="h-4 w-4" />
                    Add to contacts
                  </Link>

                  {card?.exchangeContact?.show ?
                    <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
                    : ""
                  }

                </div>
              </div>
            </div>

            {/* ------------------------------ about section -----------------------------  */}

            {personalDetails?.about ? (
              <div
                className="max-w-[361px]   mt-[20px]  rounded-[8px] items-center p-6 "
                style={{
                  backgroundColor: `${Highlightcolor ? Highlightcolor : "black"
                    }`,
                }}
              >
                <div className=" h-[34px]">
                  <p
                    className="text-[18px]  font-medium text-left"
                    style={{
                      color: `${Textcolor ? Textcolor : ""}`,
                    }}
                  >
                    About
                  </p>
                </div>

                <p
                  className="text-[14px]  font-medium text-left whitespace-pre-line"
                  style={{
                    color: `${Textcolor ? Textcolor : ""}`,
                  }}
                >
                  {personalDetails?.about}
                </p>
              </div>
            ) : (
              ""
            )}

            {/* ------------------------------ social media -----------------------------  */}


            {SocialMediaImageCheck ||
              (card?.socialMedias && card?.socialMedias?.length !== 0) ? (
              <>
                <div
                  className=" mt-5  text-white p-[16px]  rounded-[8px] "
                  style={{
                    backgroundColor: `${Highlightcolor ? Highlightcolor : "black"
                      }`,
                  }}
                >
                  <p
                    className="text-[14px]  font-semibold m-2  text-start"
                    style={{
                      color: `${Textcolor ? Textcolor : ""}`,
                    }}
                  >
                    Social Media
                  </p>
                  {/* <SlideSocialMediaStd preview={preview} color={'white'} Highlightcolor={Highlightcolor} /> */}
                  {card?.socialMedias && card?.socialMedias?.length !== 0 ? (
                    <SlideSocialMediaStandard
                      preview={preview}
                 
                      iconColor=  {iconColor = color ? color : '#FFFFFF'}
                      Highlightcolor={Highlightcolor}
                      Iconcolor={Iconcolor}
                      theme={"modern"}
                    />
                  ) : (
                    <SlideSocialMediaStd
                      preview={preview}
                     
                      iconColor=  {iconColor = color ? color : '#FFFFFF'}
                      Highlightcolor={Highlightcolor}
                      theme={"modern"}
                    />
                  )}
                </div>
              </>
            ) : (
              ""
            )}

            {/* ------------------------------ Contact -----------------------------  */}
            <div
              className=" rounded-[8px] mt-5 p-4"
              style={{
                backgroundColor: `${Highlightcolor ? Highlightcolor : "black"}`,
              }}
            >
              <p
                className="text-[14px]  font-semibold m-2  text-start"
                style={{
                  color: `${Textcolor ? Textcolor : ""}`,
                }}
              >
                Contact Information
              </p>
              <div className="mb-2 p-2">

                <ContactCardStd preview={preview} Textcolor={Textcolor} Highlightcolor={Highlightcolor} Iconcolor={Iconcolor} BtIColor={BtIColor} customButton={directionButton} />

              </div>
            </div>

            {/* ------------------------------ website  -----------------------------  */}
            {website[0]?.websiteName ? (
              <div
                className="   text-white p-[16px] mt-5  rounded-[8px] "
                style={{
                  backgroundColor: `${Highlightcolor ? Highlightcolor : "black"
                    }`,
                }}
              >
                <p
                  className="text-[14px]  font-semibold m-2  text-start"
                  style={{
                    color: `${Textcolor ? Textcolor : ""}`,
                  }}
                >
                  Website
                </p>

                {/* <WebsiteVex
                  website={website}
                  preview={preview}
                  Highlightcolor={Highlightcolor}
                  Textcolor={Textcolor}
                  BtIColor={BtIColor}
                  Iconcolor={Iconcolor}
                /> */}
                <Website website={website} preview={preview} Textcolor={Textcolor} Highlightcolor={Highlightcolor} Iconcolor={Iconcolor} BtIColor={BtIColor} />

              </div>
            ) : (
              ""
            )}

            {/* ------------------------------ review -----------------------------  */}

            {review[0]?.reviewName ? (
              <div
                className="  mb-2 mt-5   rounded-[8px]  p-6  "
                style={{
                  backgroundColor: `${Highlightcolor ? Highlightcolor : "black"
                    }`,
                }}
              >
                <p
                  className="text-[14px] text-white font-semibold  text-start"
                  style={{
                    color: `${Textcolor ? Textcolor : ""}`,
                  }}
                >
                  Review
                </p>

                <ReviewCardVex preview={preview} Textcolor={Textcolor} Iconcolor={Iconcolor} BtIColor={BtIColor} />
              </div>
            ) : (
              ""
            )}

            {/* ------------------------------ files -----------------------------  */}

            {fileName?.fileName1 ||
              fileName?.fileName2 ||
              fileName?.fileName3 ||
              fileName?.fileName4 ? (
              <div
                className=" rounded-[8px] items-center p-4"
                style={{
                  backgroundColor: `${Highlightcolor ? Highlightcolor : "black"
                    }`,
                }}
              >
                <p
                  className="text-[14px]  font-medium text-left"
                  style={{
                    color: `${Textcolor ? Textcolor : ""}`,
                  }}
                >
                  Attachments
                </p>

                <p
                  className="text-[14px] mt-3 font-medium text-left"
                  style={{
                    color: `${Textcolor ? Textcolor : ""}`,
                  }}
                >
                  <DownloadBasic
                    preview={preview}
                    fileName={fileName}
                    files={files}
                    BtIColor={BtIColor}
                    Iconcolor={Iconcolor}
                    Textcolor={Textcolor}
                  />
                </p>
              </div>
            ) : (
              ""
            )}
            
            {(card?.highlightPhotos[0]?.highlightPhotos1 ||
  card?.highlightPhotos[0]?.highlightPhotos2 ||
  card?.highlightPhotos[0]?.highlightPhotos3 ||
  card?.highlightPhotos[0]?.highlightPhotos4 ||
  card?.highlightPhotos[0]?.highlightPhotos5 ||
  card?.highlightPhotos[0]?.highlightPhotos6 ||
  card?.highlightPhotos[0]?.highlightPhotos7 ||
  card?.highlightPhotos[0]?.highlightPhotos8) ? (
    card?.checkHighlight ? (
      <div className="mt-[20px]">
        <div
          className="rounded-[8px] items-center p-4"
          style={{
            backgroundColor: `${Highlightcolor ? Highlightcolor : "black"}`,
          }}
        >
          <p
            className="text-[14px] mb-2 font-medium text-left"
            style={{
              color: `${Textcolor ? Textcolor : ""}`,
            }}
          >
            Gallery
          </p>
          {HighlightImageCheck ? <HighlightImageVex /> : null}
        </div>
      </div>
    ) : (
      "" // This acts as the fallback
    )
  ) : (
    "" // This closes the entire outer condition with an empty fallback
  )}



            {/*  --------------------------------- footer ---------------------------------  */}

          </div>
          <div className="pt-10">
          {footerText && <Footer className="" />}</div>
        </div>
       
        {preview ? (
          <div className="fixed bottom-0 right-7 z-10 space-y-4">
            {!isOpen && (
              <div className="relative group">
                <div className="flex items-center space-x-2">
                  <span
                    className="absolute -left-12 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                    style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                  >
                    Share
                  </span>
                  <button
                    onClick={toggleButtons}
                    className="border rounded-full p-2 bg-blue-500 hover:bg-blue-600 transition-transform duration-[1s] ease-in-out"
                    style={{
                      backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
                      borderColor: `${Highlightcolor ? Highlightcolor : ""}`
                    }}
                  >
                    <IoShareSocialOutline size={23} color={iconColor} />
                  </button>
                </div>
              </div>
            )}

            {isOpen && (
              <>
                {/* Profile Link Button */}
                <div
                  className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}
                  style={{ transitionDelay: '0.1s' }}
                >
                  <div className="flex items-center space-x-2">
                    <span
                      className="absolute -left-24 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                      style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                    >
                      Profile Link
                    </span>
                    <button
                      onClick={handleShare}
                      className="border-[1px] rounded-full p-2 bg-transparent transition-transform duration-[1s] ease-in-out"
                      style={{ color: `${Highlightcolor ? Highlightcolor : ""}`, borderColor: `${Highlightcolor ? Highlightcolor : ""}` }}

                    >
                      <IoLink size={23} />
                    </button>
                  </div>
                </div>

                {/* QR Code Button */}
                <div
                  className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}
                  style={{ transitionDelay: '0.2s' }}
                >
                  <div className="flex items-center space-x-2">
                    <span
                      className="absolute -left-16 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                      style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                    >
                      QR Code
                    </span>
                    <button
                      onClick={() => setQrModal(true)}
                      className="border-[1px] rounded-full p-2 bg-transparent transition-transform duration-[1s] ease-in-out" style={{ borderColor: `${Highlightcolor ? Highlightcolor : ""}` }}
                    >
                      <BsQrCodeScan size={23} style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }} />
                    </button>
                  </div>
                </div>

                {/* Close Button */}
                <div
                  className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}
                  style={{ transitionDelay: '0.3s' }}
                >
                  <div className="flex items-center space-x-2">
                    <span
                      className="absolute -left-12 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                      style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                    >
                      Close
                    </span>
                    <button
                      onClick={toggleButtons}
                      className="border rounded-full p-2 text-white cursor-pointer transition-transform duration-[1s] ease-in-out"
                      style={{ backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`, borderColor: `${Highlightcolor ? Highlightcolor : ""}` }}
                    >
                      <IoCloseOutline size={23} color={iconColor} />
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>

        ) : (
          ""
        )}
        
        {qrModal ? <QRModal handleClose={handleClose} /> : null}
      </div>
    </div>
  );
}

export default VexTheme;
